import React from "react";
import { COLORS } from "../colors";

const DallaPrivacy = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: COLORS.background,
        color: COLORS.text,
        padding: "20px",
      }}
    >
      <header
        style={{
          backgroundColor: COLORS.primary,
          color: COLORS.light,
          padding: "20px",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: "2em", fontWeight: "bold" }}>سياسة الخصوصية</h1>
      </header>

      <main
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          backgroundColor: COLORS.light,
          borderRadius: "10px",
          padding: "20px",
          marginTop: "20px",
        }}
      >
        <section>
          <h2 style={{ fontSize: "1.5em", marginBottom: "10px" }}>المقدمة</h2>
          <p>
            مرحبًا بكم في تطبيق <strong>الدلة</strong>. نحن ملتزمون بحماية
            خصوصيتكم. نود إعلامكم بأن تطبيقنا لا يجمع أي بيانات شخصية أو غير
            شخصية من المستخدمين.
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: "1.5em", marginBottom: "10px" }}>
            جمع البيانات
          </h2>
          <p>
            تطبيق <strong>الدلة</strong> هو لعبة تعتمد بالكامل على الواجهة
            الأمامية. لا يتم جمع أو تخزين أي بيانات من المستخدمين أثناء اللعب.
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: "1.5em", marginBottom: "10px" }}>
            مشاركة البيانات
          </h2>
          <p>
            نظرًا لأن التطبيق لا يجمع أي بيانات، فإنه لا يتم مشاركة أي بيانات مع
            أي طرف ثالث.
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: "1.5em", marginBottom: "10px" }}>
            أمان البيانات
          </h2>
          <p>
            بما أن التطبيق لا يجمع أو يخزن أي بيانات، فإن أمان البيانات ليس قضية
            تخص هذا التطبيق.
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: "1.5em", marginBottom: "10px" }}>
            التغييرات على هذه السياسة
          </h2>
          <p>
            قد نقوم بتحديث سياسة الخصوصية لتوضيح مزيد من التفاصيل أو لضمان
            الامتثال للقوانين. سيتم نشر أي تغييرات على هذه الصفحة.
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: "1.5em", marginBottom: "10px" }}>
            الاتصال بنا
          </h2>
          <p>
            إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يمكنك الاتصال بنا عبر
            البريد الإلكتروني التالي:{" "}
            <a href="mailto:tarbaa.kw@gmail.com">tarbaa.kw@gmail.com</a>.
          </p>
        </section>
      </main>

      <footer
        style={{
          backgroundColor: COLORS.primary,
          color: COLORS.light,
          textAlign: "center",
          padding: "20px",
          marginTop: "20px",
        }}
      >
        <p>© 2025 الدلة. جميع الحقوق محفوظة.</p>
      </footer>
    </div>
  );
};

export default DallaPrivacy;
